// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"8885":"e79c03e52b2ed347","25704":"95898c2244084e63","26829":"c4e1e18a9165afae","87793":"cc196781da9b9952","97091":"45a4fb4eff2dbe4b"}[chunkId] + ".css";
};